"use strict";

/**
 *
 * Handles the consent checkbox at the media page.
 *
 */

const $ = require("jquery");
const axios = require("axios");
const formStatus = require("./../booking-form-status/booking-form-status");

/**
 *
 * Checks if the consent is given and calls the given function or shows error
 *
 * @param {function} action The action to be performed
 */
function performOnlyWhenConsentGiven(action, onError) {
  const form = $(".js-media-consent-form");
  const checkbox = $(form).find("input[type=checkbox]");
  const isChecked = $(checkbox).is(":checked");

  if (isChecked) {
    $(form)
      .find("label")
      .removeClass("is-invalid");

    $(".upload-terms").removeClass("is-invalid");

    submitTheConsetFormBeforePerform(action, onError);
  } else {
    const message = $(".js-media-consent-form").attr("data-consenterror");

    $(form)
      .find("label")
      .addClass("is-invalid");

    $(".upload-terms").addClass("is-invalid");

    formStatus.clearStatus("js-media-consent-form-status");
    formStatus.showError("js-media-consent-form-status", message, false, true);
    $(".upload-terms")[0].scrollIntoView();
  }
}

/**
 *
 * Submit the concent button for the user and then perform the given action.
 *
 * @param {function} action The function to be called on success.
 * @param {function} onError The function to be called on error.
 */
function submitTheConsetFormBeforePerform(action, onError) {
  const wasNotChecked =
    $(".js-media-consent-form").attr("data-checked") == "false";
  const nowIsChecked = $(".js-media-consent-form input[type=checkbox]").is(
    ":checked"
  );

  if (wasNotChecked) {
    if (nowIsChecked) {
      const url = $(".js-media-consent-form").attr("action");
      const formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("_token", $("input[name=_token]").val());
      formData.append("content_use_accepted", "on");

      axios
        .post(url, formData)
        .then(function() {
          action();
        })
        .catch(function(err) {
          const message = $(".js-media-consent-form").attr("data-consenterror");
          formStatus.clearStatus("js-media-consent-form-status");
          formStatus.showError("js-media-consent-form-status", message);
          if (onError) {
            onError(err);
          }
        });
    } else {
      if (onError) {
        onError();
      }
    }
  } else {
    action();
  }
}

/**
 *
 * initializes the component.
 *
 * @param {Array<fucntion>} listOfFunction The list of functions that will be
 *    submited at the `submit` function.
 */
function onLoad(listOfFunction) {
  $(".js-media-consent-form input[type=checkbox]").on("change", function() {});

  $(".js-profile-media-submit").on("click", function() {
    $("#content_use_accepted").attr("disabled", false);
    $(".js-media-consent-form").submit();
  });

  if (
    $(".js-media-consent-form-status--error").length > 1 &&
    $(".js-media-consent-form-status--error").children().length > 0
  ) {
    $(".js-media-consent-form-status--error")
      .get(1)
      .scrollIntoView();
  }
}

module.exports = {
  onLoad,
  performOnlyWhenConsentGiven
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-profile-media-form/booking-profile-media-form.js